const TYPING_EVENT_SEPARATION_MS = 10000;

export class TypingRateLimiter {
    private nextAllowedEvent: number;

    constructor () {
        this.nextAllowedEvent = 0;
    }

    triggerTyping = (sender: () => Promise<void>) => {
        const now = Date.now();
        const delay = this.nextAllowedEvent - now;
        if (delay <= 0) {
            this.sendTypingEvent(sender);
            this.nextAllowedEvent = now + TYPING_EVENT_SEPARATION_MS;
        }
    }

    private readonly sendTypingEvent = async (sender: () => Promise<void>) => {
        try {
            await sender();
        } catch (err) {
            console.error('Failed to send typing indicator:', err);
        }
    };
}
